Storage = require('app/common/lib/storage').default
module.exports = Storage
